import { useEffect } from "react";
import { useIndustryOptions } from "../industries/api";
import { Select } from "../../components/ui";

// 検索フォームの業種プルダウン（§3.3・任意条件）。業種は「絞り込みの1条件」にすぎないので、
// 取得に失敗しても検索そのものは止めない（業種の絞り込みだけ落として続行できる）。
// 4状態: 取得中=disabled / 取得失敗=小さくエラー＋再試行（送信は止めない）/ 0件=フィルタを出さない。
export function IndustryFilterSelect({
  value,
  onChange,
  className = "!w-40",
}: {
  value: string;
  onChange: (code: string) => void;
  className?: string;
}) {
  const q = useIndustryOptions();

  // 選んだ業種が選択肢から消えた/取得に失敗したときは、絞り込み値を空へ戻す（codex#9）。
  // これをしないと select が消えても親の値が残り、「さがす」で古い（or 廃止済み）codeを送ってしまう。
  const options = q.data;
  const valueGone =
    value !== "" && (q.isError || (options != null && !options.some((o) => o.code === value)));
  useEffect(() => {
    if (valueGone) onChange("");
  }, [valueGone, onChange]);

  if (q.isLoading) {
    return (
      <Select disabled className={className}>
        <option>業種（読込中）</option>
      </Select>
    );
  }
  if (q.isError) {
    return (
      <div className="flex items-center gap-1 text-xs text-rose-500">
        <span>業種の取得に失敗</span>
        <button type="button" className="font-bold underline" onClick={() => q.refetch()}>
          再試行
        </button>
      </div>
    );
  }
  const opts = options ?? [];
  if (opts.length === 0) return null; // 0件: 業種フィルタを出さない（他条件で検索できる）

  return (
    <Select value={value} onChange={(e) => onChange(e.target.value)} className={className}>
      <option value="">業種（すべて）</option>
      {opts.map((o) => (
        <option key={o.code} value={o.code}>
          {o.label}
        </option>
      ))}
    </Select>
  );
}
